<!-- Modals -->
<app-deprecated-modal-form
    #createModal
    headerText="benefits.planIndex.addPlanModal.header"
    [form]="benefitPlanForm"
    (save)="onCreate(benefitPlanForm.benefitPlan, benefitPlanForm)"
>
    <app-form-benefit-plan #benefitPlanForm></app-form-benefit-plan>
</app-deprecated-modal-form>

<!-- Body -->
<div class="page-container" [class.loading]="isLoading">
    <app-header title="benefits.planIndex.title" [menuService]="canAccessBenefitsSettings ? benefitsMenuService : null">
        <div class="buttons">
            <ui-button type="link" [externalLink]="true" url="https://www.humi.ca/marketplace">
                {{ 'benefits.planIndex.visitMarketplace' | translate }}
            </ui-button>
            <ui-button
                *ngIf="showCreateButton && !table.isEmpty"
                [ngClass]="{ primaryCreatePlan: table.isEmpty }"
                type="primary"
                (click)="onCreatePlan()"
            >
                <mat-icon svgIcon="plus"></mat-icon>
                {{ 'benefits.planIndex.addPlan' | translate }}
            </ui-button>
        </div>
    </app-header>

    <app-table *ngIf="!table.isEmpty; else emptyState" [table]="table" class="table">
        <div class="empty">
            <img class="benefits-img" src="/assets/illustrations/benefits.png" />
            <h2 class="ui centered header">
                {{ 'benefits.planIndex.emptyPlanTable.noBenefitPlansHaveBeenAdded' | translate }}
            </h2>
            <ui-button *ngIf="showCreateButton" type="link" (click)="createModal.show()">
                {{ 'benefits.planIndex.emptyPlanTable.addABenefitPlan' | translate }}
            </ui-button>
        </div>
    </app-table>

    <ng-template #emptyState>
        <ui-card class="empty" [withSpacing]="false">
            <div class="benefits-card-container">
                <div class="add-plan-container">
                    <div class="info-container">
                        <img src="/assets/illustrations/benefits.png" />
                        <h2 class="centered">{{ 'benefits.planIndex.addBenefitsPlan.title' | translate }}</h2>
                        <p>{{ 'benefits.planIndex.addBenefitsPlan.description' | translate }}</p>
                    </div>
                    <div class="emptyStateButtons flex align-items-center">
                        <ui-button type="outline" (click)="createModal.show()">
                            <mat-icon svgIcon="plus"></mat-icon>
                            {{ 'benefits.planIndex.addPlan' | translate }}
                        </ui-button>
                    </div>
                </div>
                <div class="vertical-line-container">
                    <div class="vertical-line"></div>
                </div>
                <div class="benefits-info-container">
                    <div class="info-container">
                        <img src="/assets/illustrations/benefits-hd.png" />
                        <h2 class="centered">{{ 'benefits.planIndex.benefitsPlan.title' | translate }}</h2>
                        <p>{{ 'benefits.planIndex.benefitsPlan.description' | translate }}</p>
                    </div>
                    <div class="emptyStateButtons flex align-items-center">
                        <ui-button
                            type="outline"
                            [routerLink]="['/add-ons', 'embed']"
                            [queryParams]="{ moduleName: 'Benefits' }"
                            [openInNewTab]="true"
                        >
                            <span>{{ 'benefits.planIndex.emptyState.learnMore' | translate }}</span>
                        </ui-button>
                    </div>
                </div>
            </div>
        </ui-card>
    </ng-template>
</div>
